import { render, staticRenderFns } from "./community-preview.vue?vue&type=template&id=fcfde9f0&scoped=true&"
import script from "./community-preview.vue?vue&type=script&lang=js&"
export * from "./community-preview.vue?vue&type=script&lang=js&"
import style0 from "./community-preview.vue?vue&type=style&index=0&id=fcfde9f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfde9f0",
  null
  
)

export default component.exports